import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react'
import DropzoneComponent from 'react-dropzone-component';
import { Link } from 'react-router-dom';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../../../node_modules/react-dropzone-component/styles/filepicker.css';
import '../../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputDate from '../../inputs/date';
import FormsInputDropdown from '../../inputs/dropdown';
import FormsInputsRadioGroup from '../../inputs/radio';

const accountOptions = [
    {
        text: 'Flexible Spending Account',
        value: '1',
    },
    {
        text: 'Medical Spending Account',
        value: '2',
    }
];

const currencyOptions = [
    {
        text: 'SGD',
        value: 'sgd'
    },
    {
        text: 'USD',
        value: 'usd'
    }
]

const claimOptions = [
    {
        text: 'Medical Expenses',
        value: '1',
    },
    {
        text: 'Optics',
        value: '2',
    }
];

var componentConfig = {
    iconFiletypes: ['.jpg', '.png', '.gif'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
var djsConfig = { autoProcessQueue: false }
// var eventHandlers = { addedfile: (file) => {
//     console.log(file);
//     this.updateFileTest();
// } }

class FormsClaimFlex extends Component {
    state = {
        files: null,
        error: false,
        errorMessage: null,
        success: false
    }
    updateFileTest(file) {
        this.setState({files: file});
    }
    renderClaimSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Claims Created Successfully!</Message.Header>
                    <p>
                        <Link to="/app/claimrecords">
                            Click here to view the claims now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        // console.log('form props', this.props);
        return (
            <Formik
                initialValues={{ 
                    incurredDate: '', 
                    account: '',
                    claimCategory: '',
                    currency: '',
                    amount: '',
                    provider: '',
                    receiptNo: '',
                    claimant: 'radio1'
                }}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.props.submitFlexClaim({data: values, attachments: this.state.files, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log('done');
                        if (error) {
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.message});
                        }
                        if (result) {
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{paddingBottom: 20}}>
                        <Grid container columns={2}>
                            <Grid.Column width={16}>
                                <Message info>
                                    <Message.Header>Flex Claim Submission</Message.Header>
                                    <p>Submission Deadline For Next Payroll: 1st December 2018</p>
                                </Message>
                            </Grid.Column>

                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Claim Information
                                </Divider>
                            </Grid.Column>

                            <Grid.Column>
                                <Field name="incurredDate" component={FormsInputDate} fluid />
                            </Grid.Column>
                            <Grid.Column>
                                <FormsInputDropdown options={accountOptions} label="Claim Account" secondaryLabel="Select the account for submission"/>
                            </Grid.Column>
                            <Grid.Column>
                                <FormsInputDropdown options={claimOptions} label="Claim Category" secondaryLabel="Select the type of claim"/>
                            </Grid.Column>
                            <Grid.Column>
                                <Field name="receiptNo" label="Receipt Number" component={FormsInputsText} secondaryLabel="Input the unqiue receipt/transaction number"/>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field name="claimant" label="Claimant" component={FormsInputsRadioGroup} secondaryLabel="Select the individual in correspondence with the claim"/>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field name="provider" label="Provider" component={FormsInputsText} secondaryLabel="Input the merchant/vendor of purchase"/>
                            </Grid.Column>
                            <Grid.Column>
                                <FormsInputDropdown options={currencyOptions} label="Currency" secondaryLabel="Select the incurred currency"/>
                            </Grid.Column>
                            <Grid.Column>
                                <Field name="amount" label="Amount" component={FormsInputsText} secondaryLabel="Input the claim amount"/>
                            </Grid.Column>

                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Documents, Receipts, Proof of Purchase
                                </Divider>
                            </Grid.Column>

                            <Grid.Column width={16}>
                                <DropzoneComponent 
                                    config={componentConfig}
                                    eventHandlers={
                                        {
                                            addedfile: (file) => {
                                                console.log(file);
                                                this.updateFileTest(file);
                                            }
                                        }
                                    }
                                    djsConfig={djsConfig}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderClaimSubmissionResult()}
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button type="submit" primary disabled={isSubmitting} fluid>Submit Claim Information</Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsClaimFlex;